import App from './components/App';
import reactDOM from 'react-dom';

 reactDOM.render(<App/>, document.querySelector('#root'))
 